import React, { useState } from 'react';
import { updateOrgIikoCredentials } from '../../services/api';

// Раньше подключить iiko мог только суперадмин через /platform — админ
// организации не мог пройти этот шаг онбординга сам. Форма проверяет
// креды синхронным запросом к iiko перед сохранением (server.py:
// _test_iiko_credentials), поэтому ошибка приходит сразу, а не тихим
// пустым дашбордом после.
const IikoSetupModal = ({ onClose, onConnected }) => {
  const [form, setForm] = useState({
    iiko_base_url: '', iiko_login: '', iiko_password: '', iiko_api_key: '', iiko_organization_id: '',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const field = (key) => ({
    value: form[key],
    onChange: (e) => setForm((prev) => ({ ...prev, [key]: e.target.value })),
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      await updateOrgIikoCredentials(form);
      onConnected();
    } catch (err) {
      setError(err.response?.data?.error || 'Не удалось подключить iiko');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="ui-modal" onClick={onClose} role="presentation">
      <div className="ui-modal-box" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className="ui-modal-head">
          <h2>Подключить iiko</h2>
          <button className="ui-icon-btn" type="button" onClick={onClose} aria-label="Закрыть">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
              <path d="M19.0068 5L5.00684 19" />
              <path d="M19 19L5 5" />
            </svg>
          </button>
        </div>
        <form className="ui-form" onSubmit={handleSubmit}>
          {error && <div className="ui-inline-error">{error}</div>}
          <div className="ui-field">
            <label>Адрес сервера iiko (Office API)</label>
            <input type="text" required placeholder="https://ваш-сервер.iiko.it/resto" {...field('iiko_base_url')} />
          </div>
          <div className="ui-field">
            <label>Логин</label>
            <input type="text" required {...field('iiko_login')} />
          </div>
          <div className="ui-field">
            <label>Пароль</label>
            <input type="password" required {...field('iiko_password')} />
          </div>
          <div className="ui-field">
            <label>API-ключ (Cloud API, необязательно)</label>
            <input type="text" {...field('iiko_api_key')} />
          </div>
          <div className="ui-field">
            <label>ID организации в iiko (необязательно)</label>
            <input type="text" {...field('iiko_organization_id')} />
          </div>
          <div className="ui-form-actions">
            <button type="submit" className="ui-btn-primary" disabled={saving}>
              {saving ? 'Проверяем подключение…' : 'Подключить'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default IikoSetupModal;
